import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import Router from 'vue-router'
import axios from 'axios'


Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.use(Vant);
Vue.use(Router)

new Vue({
  render: h => h(App),
}).$mount('#app')
